import React from 'react';
import ExternalBrandLogo from '../components/ExternalBrandLogo';
import { SidebarItem } from '../graphql/generated/graphql';
import getExternalBrandLogoProps from '../integrations/getExternalBrandLogoProps';
import { isFeatureEnabled } from '../utils/features';
import { externalDisplayName } from '../utils/post/externalPost';
import EditSidebarSectionMenuItem from './EditSidebarSectionMenuItem';
import SidebarRow from './SidebarRow';
import SidebarSection from './SidebarSection';
import SidebarSectionIcon from './SidebarSectionIcon';
import { PremadeSections } from './SidebarSectionsProvider';
import useExternalPostPlatforms from './useExternalPostPlatforms';
import useSidebarSettings from './useSidebarSettings';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';

const SidebarExternalPostsSection = () => {
  const platforms = useExternalPostPlatforms();
  const { hiddenItems } = useSidebarSettings();
  const isMobile = useIsSize(Sizes.SM);

  if (platforms.length === 0) {
    return null;
  }

  return (
    <SidebarSection
      id="apps"
      icon={<SidebarSectionIcon section={{ id: 'integrations' }} />}
      title="Integrations"
      hidden={hiddenItems.has(SidebarItem.Apps)}
      menuItems={
        isFeatureEnabled('sidebar_section') &&
        !isMobile && (
          <EditSidebarSectionMenuItem
            sectionId={PremadeSections.INTEGRATIONS}
          />
        )
      }
    >
      {platforms.map(
        ({ id }) =>
          id && (
            <SidebarRow
              key={id}
              to={`/integration-posts/${id}`}
              icon={
                <ExternalBrandLogo
                  {...getExternalBrandLogoProps(id)}
                  height={12}
                />
              }
              subItem
            >
              {externalDisplayName(id)}
            </SidebarRow>
          ),
      )}
    </SidebarSection>
  );
};

export default SidebarExternalPostsSection;
